export type choice = {
  message: {
    role: string;
    content: string;
  };
  finish_reason: string;
  index: number;
};

export type ChatGptResponse = {
  id: string;
  object: string;
  created: number;
  model: string;
  usage: {
    prompt_tokens: number;
    completion_tokens: number;
    total_tokens: number;
  };
  choices: choice[];
};

export enum ChatGptRole {
  System = 'system',
  User = 'user'
}

export type ChatGptMessage = { role: ChatGptRole; content: string };

export type ChatGptRequest = {
  model: string;
  temperature: number;
  messages: ChatGptMessage[];
};
